import { Box, CircularProgress, Stack, Tooltip } from "@mui/material";
import { dateToString } from "../trips/TripSupportDialog";
import { ComputationStatus, Trip } from "../../generated/gpb/api/route";
import DoDisturbOnIcon from "@mui/icons-material/DoDisturbOn";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import { getProcessingRequestStatus, statusText } from "../trips/tripUtils";
import { HeaderContainer, StatusIconContainer } from "./TripCardStyle";
import { faCheck, faCircleExclamation, faHourglassClock } from "@fortawesome/sharp-duotone-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


type TripCardHeaderProps = {
    trip: Trip,
};

export function getStatusDisplay( status: ComputationStatus | undefined, isLarge: boolean )
{
    const statusIcon = getStatusDisplayIcon( status, isLarge );
    if ( status === ComputationStatus.DONE )
    {
        return null;
    }
    const statusTooltip = status !== undefined ? statusText( status ) : "Loading";
    return (
        <StatusIconContainer status = {status} size = {isLarge ? 24 : 20}>
            <Tooltip title = {statusTooltip}>{statusIcon}</Tooltip>
        </StatusIconContainer>
    );
}
function getStatusDisplayIcon( status: ComputationStatus | undefined, isLarge: boolean )
{
    switch ( status )
    {
        case ComputationStatus.REQUEST_PROCESSING_STATUS_UNSET:
        case ComputationStatus.UNRECOGNIZED:
            return <QuestionMarkIcon/>;
        case ComputationStatus.IN_PROGRESS:
        case ComputationStatus.WAITING:
            return <FontAwesomeIcon icon = {faHourglassClock} size = {isLarge ? "lg" : "sm"} fixedWidth/>;
        case ComputationStatus.DONE:
            return <FontAwesomeIcon icon = {faCheck} size = "xl" fixedWidth/>;
        case ComputationStatus.ERROR:
            return <FontAwesomeIcon icon = {faCircleExclamation} size = "xl" fixedWidth/>;
        case ComputationStatus.CANCELLED:
        case ComputationStatus.CANCELLING:
            return <DoDisturbOnIcon/>;
    }
    return <CircularProgress/>;
}
/**
 * TripCardHeader component to display route status, name, generated date, and revision number.
 *
 * @param {TripCardHeaderProps} props - Props containing trip.
 * @returns {JSX.Element} The rendered TripCard component.
 */
export default function TripCardHeader( { trip }: Readonly<TripCardHeaderProps> )
{
    const startDate = trip.routeRequestInput?.startDate;
    const status = getProcessingRequestStatus( trip );
    const statusIcon = getStatusDisplay( status, true );
    const isDeleted: boolean = trip.hidden;
    return (
        <HeaderContainer>
            <Box display = "flex" alignItems = "center">
                <Box>
                    <Stack direction = "row" sx = {{ paddingRight: "10px" }}>
                        <Box sx = {{ fontWeight: "bold", fontSize: "0.8rem", color: isDeleted ? "red" : "black" }}>
                            {trip.name}
                        </Box>
                    </Stack>
                </Box>
                {statusIcon}
            </Box>
            {startDate !== undefined && (
                <Box>
                    <span style = {{ fontSize: "0.8rem" }}>{dateToString( startDate )}</span>
                </Box>
            )}
        </HeaderContainer>
    );
}

